import React from 'react';
import { Helmet } from 'react-helmet-async';

const WithdrawHistory = () => {
  const withdrawHistory = [
    {
      date: '2022-11-01',
      time: '20:20:05',
      amount: 500.00,
      status: 'Paid',
    },
    {
      date: '2022-11-01',
      time: '20:20:05',
      amount: 500.00,
      status: 'Paid',
    },
    {
      date: '2022-11-01',
      time: '20:20:05',
      amount: 500.00,
      status: 'Paid',
    },
  ];

  return (
    <>
    <Helmet>
      <title>Withdrawal History | RatingApp</title>
      <meta name="description" content="Review your full USDT withdrawal history on RatingApp." />
    </Helmet>
    <div className="max-w-lg mx-auto px-4">
      <h1 className="text-white text-xl font-light text-left mb-2">Withdraw History</h1>

      <ul className="list-none p-0 m-0">
        {withdrawHistory.map((transaction, index) => (
          <li
            key={index}
            className="flex items-center justify-between bg-gradient-to-r from-[#071B57] to-[#1A407B] p-4 rounded-lg w-full mb-4"
          >
            <div>
              <h5 className="text-white text-sm">USDT Withdraw</h5>
              <p className="text-white/25 text-xs mt-1">
                {transaction.date} <span className="px-2"></span> {transaction.time}
              </p>
            </div>
            <div className="text-center w-28">
              <h6
                className="rounded-full flex justify-center text-sm mb-1 font-medium bg-gradient-to-r from-[#D9B855] to-[#E7D191] p-0.5 px-2"
              >
                <small>{transaction.status}</small>
              </h6>
              <h6 className="text-xs font-bold text-green-600">+{transaction.amount.toFixed(2)}</h6>
            </div>
          </li>
        ))}
      </ul>
    </div>
    </>
  );
};

export default WithdrawHistory;
